
import { put, takeEvery } from 'redux-saga/effects';
import { actionType } from "../../troubleShooting/search/action";
import data from "../../../assets/lang/jp/search-page";
import prodCategories from "../../../assets/lang/jp/product-category";
import api from '../../../services/API';

function* fetchSearchPageData() {
  data.data.categories = prodCategories.prodCategories;
  yield put({ type: actionType.GET_PAGE_DATA_RECEIVED, payload: data });
}

/**
 * SagaMethod to call the article list API
 * @method: search params
 * @output: object data of articles
 */
function* getArticleList(searchParams) {

  if (!searchParams.payload.searchOption.search_value.trim()) {
    yield put({
      type: actionType.SEARCH_ARTICLE_FAILURE,
      payload: { data: { statusCode: 200} }
    })
    return;
  }

  try {

    const articleList = yield api.article.getList(searchParams.payload.searchOption);

    yield put({
      type: actionType.SEARCH_ARTICLE_SUCCESS,
      payload: articleList,
      viewMore: searchParams.payload.viewMore
    })
  } catch (exception) {
    yield put({
      type: actionType.SEARCH_ARTICLE_FAILURE,
      payload: exception.response
    })
  }

}

/**
 * Call the all sagas method here
 */

export const SearchSagas = [
  takeEvery(actionType.GET_PAGE_DATA_REQUEST, fetchSearchPageData),
  takeEvery(actionType.SEARCH_ARTICLE_REQUEST, getArticleList)
]